export default [
    {
        path: 'organizations',
        name: 'organizations-organizations',
        meta: {
            modules: ['organization'],
            authentication_required: true,
            authorization_required: ['modules.organization'],
            translate: (t) => {
                return t('menu_points.organizations').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'organizations-organizations-list'},
        props: { own: false },
        children: [
            {
                path: '',
                name: 'organizations-organizations-list',
                meta: {
                    modules: ['organization'],
                    authentication_required: true,
                    authorization_required: ['modules.organization'],
                    translate: (t) => {
                        return t('menu_points.organizations').ucFirst();
                    },
                },
                component: () => import('@/views/pages/organization/organizations/list.vue'),
                props: { own: false }
            },
            {
                path: 'create',
                name: 'organizations-organization-create',
                meta: {
                    modules: ['organization'],
                    authentication_required: true,
                    authorization_required: ['modules.organization'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('organizations::organizations.organization', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/organization/organizations/item.vue'),
                props: { own: false }
            },
            {
                path: ':id(\\d+)',
                name: 'organizations-organization-edit',
                meta: {
                    modules: ['organization'],
                    authentication_required: true,
                    authorization_required: ['modules.organization'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('organizations::organizations.organization', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/organization/organizations/item.vue'),
                props: { own: false },
            },
        ]
    },
    {
        path: 'divisions',
        name: 'organizations-divisions',
        meta: {
            modules: ['organization'],
            authentication_required: true,
            authorization_required: ['roles.divisions.view'],
            translate: (t) => {
                return t('menu_points.divisions').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: {name: 'organizations-divisions-list'},
        children: [
            {
                path: '',
                name: 'organizations-divisions-list',
                meta: {
                    modules: ['organization'],
                    authentication_required: true,
                    authorization_required: ['roles.divisions.view'],
                    translate: (t) => {
                        return t('menu_points.divisions').ucFirst();
                    },
                },
                component: () => import('@/views/pages/organization/divisions/list.vue'),
            },
            {
                path: 'create',
                name: 'organizations-division-create',
                meta: {
                    modules: ['organization'],
                    authentication_required: true,
                    authorization_required: ['roles.division.create'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('organizations::divisions.division', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/organization/divisions/item.vue')
            },
            {
                path: ':id(\\d+)',
                name: 'organizations-division-edit',
                meta: {
                    modules: ['organization'],
                    authentication_required: true,
                    authorization_required: ['roles.division.update'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('organizations::divisions.division', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/organization/divisions/item.vue')
            }
        ]
    },
    {
        path: 'departments',
        name: 'organizations-departments',
        meta: {
            modules: ['organization'],
            authentication_required: true,
            authorization_required: ['roles.departments.view'],
            translate: (t) => {
                return t('menu_points.departments').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: {name: 'organizations-departments-list'},
        children: [
            {
                path: '',
                name: 'organizations-departments-list',
                meta: {
                    modules: ['organization'],
                    authentication_required: true,
                    authorization_required: ['roles.departments.view'],
                    translate: (t) => {
                        return t('menu_points.departments').ucFirst();
                    },
                },
                component: () => import('@/views/pages/organization/departments/list.vue'),
            },
            {
                path: 'create',
                name: 'organizations-department-create',
                meta: {
                    modules: ['organization'],
                    authentication_required: true,
                    authorization_required: ['roles.department.create'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('organizations::departments.department', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/organization/departments/item.vue')
            },
            {
                path: ':id(\\d+)',
                name: 'organizations-department-edit',
                meta: {
                    modules: ['organization'],
                    authentication_required: true,
                    authorization_required: ['roles.department.update'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('organizations::departments.department', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/organization/departments/item.vue')
            }
        ]
    },
    {
        path: 'teams',
        name: 'organizations-teams',
        meta: {
            modules: ['organization'],
            authentication_required: true,
            authorization_required: ['roles.teams.view'],
            translate: (t) => {
                return t('menu_points.teams').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: {name: 'organizations-teams-list'},
        children: [
            {
                path: '',
                name: 'organizations-teams-list',
                meta: {
                    modules: ['organization'],
                    authentication_required: true,
                    authorization_required: ['roles.teams.view'],
                    translate: (t) => {
                        return t('menu_points.teams').ucFirst();
                    },
                },
                component: () => import('@/views/pages/organization/teams/list.vue'),
            },
            {
                path: 'create',
                name: 'organizations-team-create',
                meta: {
                    modules: ['organization'],
                    authentication_required: true,
                    authorization_required: ['roles.team.create'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('organizations::teams.team', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/organization/teams/item.vue')
            },
            {
                path: ':id(\\d+)',
                name: 'organizations-team-edit',
                meta: {
                    modules: ['organization'],
                    authentication_required: true,
                    authorization_required: ['roles.team.update'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('organizations::teams.team', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/organization/teams/item.vue')
            }
        ]
    },
    {
        path: 'hierarchy-levels',
        name: 'organizations-hierarchy-levels',
        meta: {
            modules: ['organization'],
            authentication_required: true,
            authorization_required: ['roles.hierarchy_levels.view'],
            translate: (t) => {
                return t('menu_points.hierarchy_levels').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: {name: 'organizations-hierarchy-levels-list'},
        children: [
            {
                path: '',
                name: 'organizations-hierarchy-levels-list',
                meta: {
                    modules: ['organization'],
                    authentication_required: true,
                    authorization_required: ['roles.hierarchy_levels.view'],
                    translate: (t) => {
                        return t('menu_points.hierarchy_levels').ucFirst();
                    },
                },
                component: () => import('@/views/pages/organization/hierarchy-levels/list.vue'),
            },
            {
                path: 'create',
                name: 'organizations-hierarchy-level-create',
                meta: {
                    modules: ['organization'],
                    authentication_required: true,
                    authorization_required: ['roles.hierarchy_level.create'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('organizations::hierarchy_levels.hierarchy_level', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/organization/hierarchy-levels/item.vue')
            },
            {
                path: ':id(\\d+)',
                name: 'organizations-hierarchy-level-edit',
                meta: {
                    modules: ['organization'],
                    authentication_required: true,
                    authorization_required: ['roles.hierarchy_level.update'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('organizations::hierarchy_levels.hierarchy_level', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/organization/hierarchy-levels/item.vue')
            }
        ]
    },
    {
        path: 'hierarchical-chains',
        name: 'organizations-hierarchical-chains',
        meta: {
            modules: ['organization'],
            authentication_required: true,
            authorization_required: ['roles.hierarchical_chains.view'],
            translate: (t) => {
                return t('menu_points.hierarchical_chains').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: {name: 'organizations-hierarchical-chains-list'},
        children: [
            {
                path: '',
                name: 'organizations-hierarchical-chains-list',
                meta: {
                    modules: ['organization'],
                    authentication_required: true,
                    authorization_required: ['roles.hierarchical_chains.view'],
                    translate: (t) => {
                        return t('menu_points.hierarchical_chains').ucFirst();
                    },
                },
                component: () => import('@/views/pages/organization/hierarchical-chains/list.vue'),
            },
            {
                path: 'create',
                name: 'organizations-hierarchical-chain-create',
                meta: {
                    modules: ['organization'],
                    authentication_required: true,
                    authorization_required: ['roles.hierarchical_chain.create'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('organizations::hierarchical_chains.hierarchical_chain', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/organization/hierarchical-chains/item.vue')
            },
            {
                path: ':id(\\d+)',
                name: 'organizations-hierarchical-chain-edit',
                meta: {
                    modules: ['organization'],
                    authentication_required: true,
                    authorization_required: ['roles.hierarchical_chain.update'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('organizations::hierarchical_chains.hierarchical_chain', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/organization/hierarchical-chains/item.vue')
            }
        ]
    },
    {
        path: 'contributors',
        name: 'organizations-contributors',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.contributors').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'organizations-contributors-list' },
        children: [
            {
                path: '',
                name: 'organizations-contributors-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.contributors').ucFirst();
                    },
                },
                component: () => import('@/views/pages/organization/contributors/list.vue'),
            },
            {
                path: 'create',
                name: 'organizations-contributor-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.create_new_item', {item: tc('organizations::contributors.contributor', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/organization/contributors/item.vue'),
            },
            {
                path: ':id(\\d+)',
                name: 'organizations-contributor-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.edit_item', {item: tc('organizations::contributors.contributor', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/organization/contributors/item.vue'),
            },
        ]
    },
];
